import * as THREE from 'three';

export type Ocean = {
  mesh: THREE.Mesh;
  foam: THREE.Mesh;
  tick(t: number): void;
};

/**
 * Blue-green sheet south of the beach. Foam sits on the waterline at z≈16.
 * `wreck.jpg` is unused here on purpose.
 */
export function addOcean(parent: THREE.Object3D): Ocean {
  const geo = new THREE.PlaneGeometry(180, 100, 48, 28);
  geo.rotateX(-Math.PI / 2);
  const pos = geo.getAttribute('position');
  const baseY = new Float32Array(pos.count);
  for (let i = 0; i < pos.count; i++) {
    baseY[i] = pos.getY(i);
  }

  const mat = new THREE.MeshPhysicalMaterial({
    color: 0x1a5f68,
    roughness: 0.22,
    metalness: 0.08,
    transparent: true,
    opacity: 0.78,
    clearcoat: 0.32,
    clearcoatRoughness: 0.45,
    depthWrite: false,
  });
  const mesh = new THREE.Mesh(geo, mat);
  mesh.name = 'CC-OCEAN';
  mesh.userData.id = 'CC-OCEAN';
  mesh.position.set(0, 0.03, 64);
  mesh.receiveShadow = false;
  mesh.renderOrder = 1;
  parent.add(mesh);

  const foamMat = new THREE.MeshStandardMaterial({
    color: 0xdce8e4,
    roughness: 0.55,
    metalness: 0.02,
    transparent: true,
    opacity: 0.55,
    depthWrite: false,
  });
  const foam = new THREE.Mesh(new THREE.PlaneGeometry(150, 5.2, 20, 2), foamMat);
  foam.name = 'CC-FOAM';
  foam.userData.id = 'CC-FOAM';
  foam.rotation.x = -Math.PI / 2;
  foam.position.set(0, 0.09, 16.1);
  foam.renderOrder = 2;
  parent.add(foam);

  return {
    mesh,
    foam,
    tick(t: number): void {
      for (let i = 0; i < pos.count; i++) {
        const x = pos.getX(i);
        const z = pos.getZ(i);
        const y =
          (baseY[i] ?? 0) +
          Math.sin(x * 0.15 + t * 1.05) * 0.11 +
          Math.sin(z * 0.12 + t * 0.7) * 0.07;
        pos.setY(i, y);
      }
      pos.needsUpdate = true;
      foam.position.y = 0.08 + Math.sin(t * 1.3) * 0.02;
      foamMat.opacity = 0.42 + Math.sin(t * 0.9) * 0.1;
    },
  };
}
